import { memo } from 'react';
import "./CircularProgress.linaria.module.css!=!./CircularProgress?./CircularProgress.linaria.module.css?css=H4sIAAAAAAAAA22R0W6DMAxF3/cVPK5SUxHWdsAe9yGRCQEMaZI6SYFV+/eJdu26aW+Wfc+15buBcBCFF9zmGufjuUbvNMwlGo1GsUpbObx9Pm0WmRNN7XexOIPBAwS0piQbLkXCN1ufLAhQgqZBg0HdOJ7Xp+l1FLzP8n7K/usl/tSeK5BDSzaamkmrLZWBwHgHpEy4eRXUdaPgx482hv2FukpPQM+MSSQZNRBzZFtS3l+N1sn32JpA4ANDaY1fre4H+oKyvRY8ajU11cX29ohfH6Cxn7tacHrhcnQXnQ9kB1XKSMuZ78u6u+10zOOrFTyvdAX1g5zV4DsggrnMUzetszR10x1D1+77UWDtmnb7l7JN41Uo059QdmiHXf8Qiu8IzXCNRIFXDA2zMTzm8gXiItFz9wEAAA=="
const circularProgressStyles = "atm_9s_1o8liyq atm_p_fds5u9 atm_18dvx7w_1j28jx2 atm_9rhhw_1qzgut6 atm_1s9r26l_1ulexfb atm_rwjyhd_1r31cwp atm_1xq8u7o_18blbad atm_1ipg6jw_idpfg4";
const shrinkStyles = "atm_p_5iok5j";
type ProgressProps = {
  disableShrink?: boolean;
  size?: number | string;
};
const Progress = ({
  disableShrink = false,
  size = 40
}: ProgressProps) => <span style={{
  width: size,
  height: size
}} className={circularProgressStyles}>
        <svg viewBox="22 22 44 44">
            <circle cx="44" cy="44" r="20" fill="none" strokeWidth="3.6" className={disableShrink ? null : shrinkStyles} />
        </svg>
    </span>;
export default memo(Progress);